const democonstants = {
    HOMELIST:[
        {
            category:"qt",
            deviceState:{
                battery: 100,
                state: "CLOSED",
            },
            deviceType:"SensorDo",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainSensor",
            modelName:null,
            name:"현관문 도어센서",
            online: true,
        },
        {
            category:"qt",
            deviceState:{
                battery: 100,
                state: "CLOSED",
            },
            deviceType:"SensorDo",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomSensor",
            modelName:null,
            name:"베란다 도어센서",
            online: true,
        },
        {
            category:"cl",
            deviceState:{
                control:"close",
                percentState:0,
                workState:"closing",
                percentControl:0,
            },
            deviceType:"Curtain",
            familyId:"0000001",
            hasSubDevices:false,
            id: "roomCurtain",
            modelName: null,
            name:"안방 스마트 전동 커튼",
            online: true
        },
        {
            category:"cl",
            deviceState:{
                control:"close",
                percentState:0,
                workState:"closing",
                percentControl:0,
            },
            deviceType:"Curtain",
            familyId:"0000001",
            hasSubDevices:false,
            id: "mainCurtain",
            modelName: null,
            name:"거실 스마트 전동 커튼",
            online: true
        },
        {
            category:"kg",
            deviceState:{
                power1: true,
                power2: true,
            },
            deviceType:"Switch2",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomSwitch",
            modelName:null,
            name:"안방 스마트 조명 스위치",
            online: true,
        },
        {
            category:"kg",
            deviceState:{
                power1: true,
                power2: true,
                power3: true,
                power4: true,
            },
            deviceType:"Switch4",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainSwitch",
            modelName:null,
            name:"거실 스마트 조명 스위치",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LedStripRgbw1",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomLineLED",
            modelName:null,
            name:"침대 스마트 라인 LED",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LedStripRgbw2",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainLineLED",
            modelName:null,
            name:"소파 스마트 라인 LED",
            online: true,
        },
    
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LedStripRgb",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainTvLineLED",
            modelName:null,
            name:"TV 옆 스마트 라인 LED",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WH",
                power: true,
            },
            deviceType:"LightRgbw2",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomSmartBulb",
            modelName:null,
            name:"침대 옆 스마트 전구",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WH",
                power: true,
            },
            deviceType:"LightRgbw2",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainSmartBulb",
            modelName:null,
            name:"소파 옆 스마트 전구",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LightRgbw4",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomMood",
            modelName:null,
            name:"책상 스마트 무드등",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LightRgbw4",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainMood",
            modelName:null,
            name:"거실 테이블 스마트 무드등",
            online: true,
        },
        {
            category:"infrared_projector",
            deviceState:null,
            deviceType:"IrProjector",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomBeam",
            modelName:null,
            name:"안방 빔 프로젝터",
            online: true,
        },
        {
            category:"infrared_tv",
            deviceState:null,
            deviceType:"IrTv",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainTV",
            modelName:null,
            name:"거실 TV",
            online: true,
        },
        {
            category:"infrared_ac",
            deviceState:{
                fanSpeed: 1,
                mode: 1,
                power: "켜짐",
                temperature: "23",
            },
            deviceType:"IrAirconditioner",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainAir",
            modelName:null,
            name:"거실 에어컨",
            online: true,
        },
    ],
    HOMEROOMLIST:[
        {
            category:"qt",
            deviceState:{
                battery: 100,
                state: "CLOSED",
            },
            deviceType:"SensorDo",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomSensor",
            modelName:null,
            name:"베란다 도어센서",
            online: true,
        },
        {
            category:"cl",
            deviceState:{
                control:"close",
                percentState:0,
                workState:"closing",
                percentControl:0,
            },
            deviceType:"Curtain",
            familyId:"0000001",
            hasSubDevices:false,
            id: "roomCurtain",
            modelName: null,
            name:"안방 스마트 전동 커튼",
            online: true
        },
        {
            category:"kg",
            deviceState:{
                power1: true,
                power2: true,
            },
            deviceType:"Switch2",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomSwitch",
            modelName:null,
            name:"안방 스마트 조명 스위치",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LedStripRgbw1",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomLineLED",
            modelName:null,
            name:"침대 스마트 라인 LED",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WH",
                power: true,
            },
            deviceType:"LightRgbw2",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomSmartBulb",
            modelName:null,
            name:"침대 옆 스마트 전구",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LightRgbw4",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomMood",
            modelName:null,
            name:"책상 스마트 무드등",
            online: true,
        },
        {
            category:"infrared_projector",
            deviceState:null,
            deviceType:"IrProjector",
            familyId:"0000001",
            hasSubDevices:false,
            id:"roomBeam",
            modelName:null,
            name:"안방 빔 프로젝터",
            online: true,
        },
    ],
    HOMELIVINGROOMLIST:[
        {
            category:"qt",
            deviceState:{
                battery: 100,
                state: "CLOSED",
            },
            deviceType:"SensorDo",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainSensor",
            modelName:null,
            name:"현관문 도어센서",
            online: true,
        },
        {
            category:"cl",
            deviceState:{
                control:"close",
                percentState:0,
                workState:"closing",
                percentControl:0,
            },
            deviceType:"Curtain",
            familyId:"0000001",
            hasSubDevices:false,
            id: "mainCurtain",
            modelName: null,
            name:"거실 스마트 전동 커튼",
            online: true
        },
        {
            category:"kg",
            deviceState:{
                power1: true,
                power2: true,
                power3: true,
                power4: true,
            },
            deviceType:"Switch4",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainSwitch",
            modelName:null,
            name:"거실 스마트 조명 스위치",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LedStripRgbw2",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainLineLED",
            modelName:null,
            name:"소파 스마트 라인 LED",
            online: true,
        },
    
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LedStripRgb",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainTvLineLED",
            modelName:null,
            name:"TV 옆 스마트 라인 LED",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WH",
                power: true,
            },
            deviceType:"LightRgbw2",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainSmartBulb",
            modelName:null,
            name:"소파 옆 스마트 전구",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LightRgbw4",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainMood",
            modelName:null,
            name:"거실 테이블 스마트 무드등",
            online: true,
        },
        {
            category:"infrared_tv",
            deviceState:null,
            deviceType:"IrTv",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainTV",
            modelName:null,
            name:"거실 TV",
            online: true,
        },
        {
            category:"infrared_ac",
            deviceState:{
                fanSpeed: 1,
                mode: 1,
                power: "켜짐",
                temperature: "23",
            },
            deviceType:"IrAirconditioner",
            familyId:"0000001",
            hasSubDevices:false,
            id:"mainAir",
            modelName:null,
            name:"거실 에어컨",
            online: true,
        },
    ],

    CAFELIST:[
        {
            category:"qt",
            deviceState:{
                battery: 100,
                state: "CLOSED",
            },
            deviceType:"SensorDo",
            familyId:"0000002",
            hasSubDevices:false,
            id:"hallDoorSensor",
            modelName:null,
            name:"정문 도어센서",
            online: true,
        },
        {
            category:"cl",
            deviceState:{
                control:"close",
                percentState:0,
                workState:"closing",
                percentControl:0,
            },
            deviceType:"Curtain",
            familyId:"0000002",
            hasSubDevices:false,
            id: "hallCurtain",
            modelName: null,
            name:"홀 스마트 전동 커튼",
            online: true
        },
        {
            category:"cl",
            deviceState:{
                control:"close",
                percentState:0,
                workState:"closing",
                percentControl:0,
            },
            deviceType:"Curtain",
            familyId:"0000002",
            hasSubDevices:false,
            id: "kitchenCurtain",
            modelName: null,
            name:"주방 스마트 전동 커튼",
            online: true
        },
        {
            category:"kg",
            deviceState:{
                power1: true,
                power2: true,
            },
            deviceType:"Switch2",
            familyId:"0000002",
            hasSubDevices:false,
            id:"hallSwitch",
            modelName:null,
            name:"홀 조명 스위치",
            online: true,
        },
        {
            category:"kg",
            deviceState:{
                power1: true,
                power2: true,
                power3: true,
                power4: true,
            },
            deviceType:"Switch4",
            familyId:"0000002",
            hasSubDevices:false,
            id:"kitchenSwitch",
            modelName:null,
            name:"주방 조명 스위치",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WH",
                power: true,
            },
            deviceType:"LightRgbw2",
            familyId:"0000002",
            hasSubDevices:false,
            id:"hallStandBulb",
            modelName:null,
            name:"홀 스탠드 스마트 전구",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WH",
                power: true,
            },
            deviceType:"LightRgbw2",
            familyId:"0000002",
            hasSubDevices:false,
            id:"kitchenSmartBulb",
            modelName:null,
            name:"주방 다운라이트 스마트 전구",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LedStripRgbw1",
            familyId:"0000002",
            hasSubDevices:false,
            id:"hallLineLED",
            modelName:null,
            name:"홀 스마트 라인 LED",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LedStripRgbw2",
            familyId:"0000002",
            hasSubDevices:false,
            id:"kitchenLineLED",
            modelName:null,
            name:"매대 스마트 라인 LED",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LightRgbw4",
            familyId:"0000002",
            hasSubDevices:false,
            id:"kitchenMood",
            modelName:null,
            name:"매대 스마트 무드등",
            online: true,
        },
        {
            category:"infrared_projector",
            deviceState:null,
            deviceType:"IrProjector",
            familyId:"0000002",
            hasSubDevices:false,
            id:"hallBeam",
            modelName:null,
            name:"홀 빔 프로젝터",
            online: true,
        },
        {
            category:"infrared_ac",
            deviceState:{
                fanSpeed: 1,
                mode: 1,
                power: "켜짐",
                temperature: "23",
            },
            deviceType:"IrAirconditioner",
            familyId:"0000002",
            hasSubDevices:false,
            id:"kitchenAir",
            modelName:null,
            name:"주방 에어컨",
            online: true,
        },
    ],
    
    CAFEKITCHENLIST:[
        {
            category:"cl",
            deviceState:{
                control:"close",
                percentState:0,
                workState:"closing",
                percentControl:0,
            },
            deviceType:"Curtain",
            familyId:"0000002",
            hasSubDevices:false,
            id: "kitchenCurtain",
            modelName: null,
            name:"주방 스마트 전동 커튼",
            online: true
        },
        {
            category:"kg",
            deviceState:{
                power1: true,
                power2: true,
                power3: true,
                power4: true,
            },
            deviceType:"Switch4",
            familyId:"0000002",
            hasSubDevices:false,
            id:"kitchenSwitch",
            modelName:null,
            name:"주방 조명 스위치",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WH",
                power: true,
            },
            deviceType:"LightRgbw2",
            familyId:"0000002",
            hasSubDevices:false,
            id:"kitchenSmartBulb",
            modelName:null,
            name:"주방 다운라이트 스마트 전구",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LedStripRgbw2",
            familyId:"0000002",
            hasSubDevices:false,
            id:"kitchenLineLED",
            modelName:null,
            name:"매대 스마트 라인 LED",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LightRgbw4",
            familyId:"0000002",
            hasSubDevices:false,
            id:"kitchenMood",
            modelName:null,
            name:"매대 스마트 무드등",
            online: true,
        },
        {
            category:"infrared_ac",
            deviceState:{
                fanSpeed: 1,
                mode: 1,
                power: "켜짐",
                temperature: "23",
            },
            deviceType:"IrAirconditioner",
            familyId:"0000002",
            hasSubDevices:false,
            id:"kitchenAir",
            modelName:null,
            name:"주방 에어컨",
            online: true,
        },
    ],

    CAFEHALLLIST:[
        {
            category:"qt",
            deviceState:{
                battery: 100,
                state: "CLOSED",
            },
            deviceType:"SensorDo",
            familyId:"0000002",
            hasSubDevices:false,
            id:"hallDoorSensor",
            modelName:null,
            name:"정문 도어센서",
            online: true,
        },
        {
            category:"cl",
            deviceState:{
                control:"close",
                percentState:0,
                workState:"closing",
                percentControl:0,
            },
            deviceType:"Curtain",
            familyId:"0000002",
            hasSubDevices:false,
            id: "hallCurtain",
            modelName: null,
            name:"홀 스마트 전동 커튼",
            online: true
        },
        {
            category:"kg",
            deviceState:{
                power1: true,
                power2: true,
            },
            deviceType:"Switch2",
            familyId:"0000002",
            hasSubDevices:false,
            id:"hallSwitch",
            modelName:null,
            name:"홀 조명 스위치",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WH",
                power: true,
            },
            deviceType:"LightRgbw2",
            familyId:"0000002",
            hasSubDevices:false,
            id:"hallStandBulb",
            modelName:null,
            name:"홀 스탠드 스마트 전구",
            online: true,
        },
        {
            category:"dj",
            deviceState:{
                brightness:100,
                hsvColor:{
                    hue:180,
                    saturation:100,
                    brightness: 100,
                },
                lightMode:"WHITE",
                power: true,
            },
            deviceType:"LedStripRgbw1",
            familyId:"0000002",
            hasSubDevices:false,
            id:"hallLineLED",
            modelName:null,
            name:"홀 스마트 라인 LED",
            online: true,
        },
        {
            category:"infrared_projector",
            deviceState:null,
            deviceType:"IrProjector",
            familyId:"0000002",
            hasSubDevices:false,
            id:"hallBeam",
            modelName:null,
            name:"홀 빔 프로젝터",
            online: true,
        },
    ],

    DEVICELIST: [
    {
        category:"kg",
        deviceState:{
            power1: true,
        },
        deviceType:"Switch1",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"스위치 1구",
        online: true,
    },
    {
        category:"kg",
        deviceState:{
            power1: true,
            power2: true,
        },
        deviceType:"Switch2",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"스위치 2구",
        online: true,
    },
    {
        category:"kg",
        deviceState:{
            power1: true,
            power2: true,
            power3: true,
        },
        deviceType:"Switch3",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"스위치 3구",
        online: true,
    },
    {
        category:"kg",
        deviceState:{
            power1: true,
            power2: true,
            power3: true,
            power4: true,
        },
        deviceType:"Switch4",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"스위치 4구",
        online: true,
    },
    {
        category:"kg",
        deviceState:{
            power1: true,
            power2: true,
            power3: true,
            power4: true,
            power5: true,
        },
        deviceType:"Switch5",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"스위치 5구",
        online: true,
    },
    
    {
        
        "deviceState": {
            "power1": true,
            "power2": true,
            "power3": true,
            "power4": true,
            "power5": true,
            "power6": true
        },
        "deviceType": "Switch6",
        "familyId": "15508789",
        "hasSubDevices": false,
        "id": "ebcece168d00376b9ezr1c17",
        "modelName": null,
        "name": "스위치 6구",
        "online": true
    },
    {
        "deviceState": {
            "power1": true,
        },
        "deviceType": "ZigbeeSwitch1",
        "familyId": "15508789",
        "hasSubDevices": false,
        "id": "",
        "modelName": null,
        "name": "스위치 1구 Zigbee",
        "online": true
    },
    {
    
        "deviceState": {
            "power1": true,
            "power2": true,
        },
        "deviceType": "ZigbeeSwitch2",
        "familyId": "15508789",
        "hasSubDevices": false,
        "id": "",
        "modelName": null,
        "name": "스위치 2구 Zigbee",
        "online": true
    },
    {
    
        "deviceState": {
            "power1": true,
            "power2": true,
            "power3": true,
        },
        "deviceType": "ZigbeeSwitch3",
        "familyId": "15508789",
        "hasSubDevices": false,
        "id": "",
        "modelName": null,
        "name": "스위치 3구 Zigbee",
        "online": true
    },
    {
        
        "deviceState": {"shutter": false},
        "deviceType": "IrCamera",
        "familyId": "15508789",
        "hasSubDevices": false,
        "id": "ebcece168d00376b9ezr1c10",
        "modelName": null,
        "name": "카메라",
        "online": true
    },

    {
    
        "deviceState": {"value": "전원"},
        "deviceType": "IrDIY",
        "familyId": "15508789",
        "hasSubDevices": false,
        "id": "ebcece168d00376b9ezr1c1100",
        "modelName": null,
        "name": "DIY",
        "online": true
    },
    
    {
        category:"infrared_light",
        deviceState:null,
        deviceType:"IrLamp",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"스탠드 등",
        online: true,
    },
    {
        category:"dj",
        deviceState:{
            brightness:100,
            temperature: 100,
            power: true,
        },
        deviceType:"LightWw1",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"전구 Ww1",
        online: true,
    },
    {
        category:"dj",
        deviceState:{
            brightness:100,
            temperature: 100,
            power: true,
        },
        deviceType:"LightWw2",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"전구 Ww2",
        online: true,
    },
    {
        category:"dj",
        deviceState:{
            brightness:100,
            temperature: 100,
            power: true,
        },
        deviceType:"LightWw3",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"전구 Ww3",
        online: true,
    },
    {
        category:"dj",
        deviceState:{
            brightness:100,
            hsvColor:{
                hue:180,
                saturation:100,
                brightness: 100,
            },
            lightMode:"WH",
            power: true,
        },
        deviceType:"LightRgbw1",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"전구RGB1",
        online: true,
    },
    
    {
        category:"dj",
        deviceState:{
            brightness:100,
            hsvColor:{
                hue:180,
                saturation:100,
                brightness: 100,
            },
            lightMode:"WHITE",
            power: true,
        },
        deviceType:"LightRgbw2",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"전구RGB2",
        online: true,
    },
    {
        category:"dj",
        deviceState:{
            brightness:100,
            hsvColor:{
                hue:180,
                saturation:100,
                brightness: 100,
            },
            lightMode:"WHITE",
            power: true,
        },
        deviceType:"LightRgbw3",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"전구RGB3",
        online: true,
    },
    {
        category:"dj",
        deviceState:{
            brightness:100,
            hsvColor:{
                hue:180,
                saturation:100,
                brightness: 100,
            },
            lightMode:"WHITE",
            power: true,
        },
        deviceType:"LightRgbw4",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"무드등",
        online: true,
    },
    {
        category:"dj",
        deviceState:{
            brightness:100,
            hsvColor:{
                hue:180,
                saturation:100,
                brightness: 100,
            },
            lightMode:"WHITE",
            power: true,
        },
        deviceType:"LightRgb5",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"전구RGB5",
        online: true,
    },
    {
        category:"dj",
        deviceState:{
            brightness:100,
            hsvColor:{
                hue:180,
                saturation:100,
                brightness: 100,
            },
            lightMode:"WHITE",
            power: true,
        },
        deviceType:"LedStripRgbw1",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"라인 LED1",
        online: true,
    },
    {
        category:"dj",
        deviceState:{
            brightness:100,
            hsvColor:{
                hue:180,
                saturation:100,
                brightness: 100,
            },
            lightMode:"WHITE",
            power: true,
        },
        deviceType:"LedStripRgbw2",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"라인 LED2",
        online: true,
    },

    {
        category:"dj",
        deviceState:{
            brightness:100,
            hsvColor:{
                hue:180,
                saturation:100,
                brightness: 100,
            },
            lightMode:"WHITE",
            power: true,
        },
        deviceType:"LedStripRgb",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"라인 LED",
        online: true,
    },
    {
        category:"cz",
        deviceState:{
            curCurrent:0,
            curPower:0,
            culVoltage: 2185,
            power: true,
        },
        deviceType:"SmartPlug",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"스마트 플러그",
        online: true,
    },
    {
        category:"cl",
        deviceState:{
            control:"close",
            percentState:0,
            workState:"closing",
            percentControl:0,
        },
        deviceType:"Curtain",
        familyId:"0000001",
        hasSubDevices:false,
        id: "",
        modelName: null,
        name:"전동 커튼",
        online: true
    },
    {
        category:"kg",
        deviceState:{
            power1: true,
        },
        deviceType:"RelayController",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"릴레이 컨트롤러",
        online: true,
    },
    {
        category:"kj",
        deviceState:{
            mode:"manual",
            pm25:"10",
            power:"true",
        },
        deviceType:"Airpurifier",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"공기청정기",
        online: true,
    },
    {
        category:"infrared_tv",
        deviceState:null,
        deviceType:"IrTv",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"TV",
        online: true,
    },
    {
        category:"infrared_box",
        deviceState:null,
        deviceType:"IrTvbox",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"TV Box",
        online: true,
    },
    {
        category:"infrared_fan",
        deviceState:null,
        deviceType:"IrFan",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"선풍기",
        online: true,
    },
    {
        category:"infrared_amplifier",
        deviceState:null,
        deviceType:"IrSpeaker",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"스피커",
        online: true,
    },
    {
        category:"infrared_projector",
        deviceState:null,
        deviceType:"IrProjector",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"빔 프로젝터",
        online: true,
    },
    {
        category:"qt",
        deviceState:null,
        deviceType:"IrDvd",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"DVD",
        online: true,
    },
    {
        category:"infrared_stb",
        deviceState:null,
        deviceType:"IrSettopbox",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"셋업 박스",
        online: true,
    },
    {
        category:"infrared_ac",
        deviceState:{
            fanSpeed: 1,
            mode: 1,
            power: "켜짐",
            temperature: "23",
        },
        deviceType:"IrAirconditioner",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"에어컨",
        online: true,
    },
    {
        category:"qt",
        deviceState:{
            battery: 100,
            state: "CLOSED",
        },
        deviceType:"SensorDo",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"도어 센서",
        online: true,
    },
    {
        category:"qt",
        deviceState:{
            temperature: 25,
            humidity: 30,
            battery: 100,
        },
        deviceType:"SensorTh",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"온습도 센서",
        online: true,
    },
    {
        category:"qt",
        deviceState:{
            battery: 100,
        },
        deviceType:"SensorMo",
        familyId:"0000001",
        hasSubDevices:false,
        id:"",
        modelName:null,
        name:"모션 센서",
        online: true,
    },
    ],
}


export default democonstants;